@import 'styles/variables';
@import 'styles/mixins';

.picker {
  padding: 8px;
  :global {
    .react-colorful {
      width: 100%;
    }

    .react-colorful__saturation {
      margin-bottom: 8px;
      border-radius: 4px;
    }

    .react-colorful__hue,
    .react-colorful__alpha {
      height: 12px;
      margin-bottom: 8px;
      border-radius: 4px;
    }

    .react-colorful__saturation-pointer,
    .react-colorful__hue-pointer,
    .react-colorful__alpha-pointer {
      width: 16px;
      height: 16px;
    }
  }
}

.swatches {
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  gap: 8px;
}

.swatch {
  width: 16px;
  height: 16px;
  background-color: var(--swatch-color);
  border-radius: 6px;
  border: 1px solid var(--dark-4);
}
